import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowDown01Icon,
  ContactBookIcon,
  MoreVerticalCircle01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { ContactFormsSubmenuVariant } from "./types";

interface ContactFormsMenuTriggerProps {
  variant: ContactFormsSubmenuVariant;
  disabled?: boolean;
}

export const ContactFormsMenuTrigger = ({
  variant,
  disabled
}: ContactFormsMenuTriggerProps) => {
  if (variant === "BUTTON")
    return (
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        disabled={disabled}
        HugeIcon={ArrowDown01Icon}
        iconStrokeWidth={3}
        iconPosition="right"
      >
        Copy contact form
      </Button>
    );

  return (
    <div className="-mx-4 -my-2 w-[272px] h-12">
      <div className="flex items-center justify-between w-full gap-3 px-4 py-2.5">
        <div className="flex items-center gap-3 flex-1 py-1">
          <HugeiconsIcon
            icon={ContactBookIcon}
            size={20}
            stroke="1px"
            className="text-content-200"
          />
          <h2 className="text-base text-content-1000 font-medium">
            Copy contact form
          </h2>
        </div>
        <HugeiconsIcon
          icon={MoreVerticalCircle01Icon}
          size={20}
          className="text-content-1000 fill-content-1000"
        />
      </div>
    </div>
  );
};
